module.exports = __webpack_public_path__ + "img/partner-logo.4d2e93ef.png";